import { AmplitudeEventType } from "~/types/global"

import { isValidEnvironment } from "./helpers"

let amplitudeEventsQueue = [] as AmplitudeEventType[]

const MAX_QUEUE_SIZE = 100

const amplitudeIgnoreEvents = ["Login Successful"]

export function amplitudeSetup({
  user,
  tenantId
}: {
  user: { id: string; name: string; email: string }
  tenantId: string
}) {
  if (!isValidEnvironment) {
    return
  }
  const isDev = import.meta.env.isDev === true
  const projectKey = isDev
    ? "dbea95b6acc65547ccf52724f56c13d8"
    : "554265e1e6d7c0638a9214a10afc0009"
  import("amplitude-js").then((module) => {
    const amplitude = module.default
    window.amplitude = amplitude
    const email = user?.email ?? ""
    amplitude.getInstance().init(projectKey, email, {
      sessionTimeout: 86400,
      userId: email,
      disableCookies: true,
      includeUtm: true,
      includeGclid: true,
      includeReferrer: true,
      storage: "localStorage",
      transport: "http",
      useNativeDeviceInfo: true,
      saveParamsReferrerOncePerSession: true,
      apiEndpoint: "prodapi.orbitshift.ai/event-logs",
      logLevel: "DISABLE",
      batchEvents: true
    })
    const event = new amplitude.Identify()
    if (email && tenantId) {
      event.set("tenant_id", tenantId)
      event.set("email", email)
      event.set("name", user.name)
      event.set("app_user_id", user.id)
    }
    amplitude.getInstance().logEvent("session_start", {
      page: window.location.pathname,
      timestamp: new Date().toISOString()
    })
    Promise.resolve(amplitude.identify(event)).then(() => {
      if (amplitudeEventsQueue.length > 0) {
        amplitudeEventsQueue.forEach((event) => {
          track(event.name, event.eventProperties)
        })
        amplitudeEventsQueue = []
      }
    })
  })
}

export async function track(
  name: string,
  eventProperties?: Record<string, any> | undefined
) {
  if (!name) return
  const sessionId = window.amplitude?.getSessionId?.()
  const userId = window.amplitude?.getInstance?.().options.userId
  if (amplitudeIgnoreEvents.includes(name)) {
    amplitudeEventsQueue.push({ name, eventProperties })
    if (amplitudeEventsQueue.length > MAX_QUEUE_SIZE) {
      amplitudeEventsQueue.shift()
    }
  }
  if (!isValidEnvironment || !sessionId || userId?.includes("orbitshift"))
    return
  if (!window.amplitude) {
    return
  }
  return new Promise((resolve) => {
    window.amplitude.logEvent(name, eventProperties, resolve)
  })
}
